import { useGetProviderById } from '@/apis/providers/hooks/useGetProviderById'
import { useApplicantProgramYears } from '@/app/SchoolYearProvider.tsx'
import MultiQueryPageLoader from '@/app/common/components/PageLoader/MultiQueryPageLoader'
import ProviderItems from '@/app/pages/marketplace/marketplace-live/providers/ProviderItems'
import { useMarketplaceItemsByProvider } from '@/queries/marketplace/hooks.ts'
import { useDebounce } from '@uidotdev/usehooks'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePagination } from '@/common/hooks/usePagination.tsx'
import { AppRoutePaths } from '@/routing/route_paths'
import { MarketplaceItem } from '@/apis/marketplace/marketplace.schema'

const ProviderDetail = () => {
  const { selectedProgramId } = useApplicantProgramYears()
  const { providerId } = useParams()
  const navigate = useNavigate()

  const [search, setSearch] = useState('')
  const [selectedFilter, setSelectedFilter] = useState<string>('')
  const debouncedSearch = useDebounce(search, 500)

  const { currentPage, perPage, setCurrentPage, setPerPage } = usePagination()

  const marketplaceItemsQuery = useMarketplaceItemsByProvider(
    selectedProgramId,
    Number(providerId),
    selectedFilter,
    debouncedSearch,
    perPage,
    currentPage
  )

  function onItemClick(item: MarketplaceItem) {
    const path = AppRoutePaths.marketplace.details.index.replace(
      ':itemId',
      item.id.toString()
    )
    const url = item.third_party_item?.id
      ? `${path}?third_party_item_id=${item.third_party_item.id}`
      : path
    navigate(url)
  }

  const providerQuery = useGetProviderById(providerId as string)

  return (
    <MultiQueryPageLoader queries={[marketplaceItemsQuery, providerQuery]}>
      {([marketplaceItems, provider]) => {
        const items = marketplaceItems?.data ?? []
        const totalRecords = marketplaceItems?.total ?? 0

        return (
          <ProviderItems
            provider={provider}
            items={items}
            search={search}
            onItemClick={onItemClick}
            setSearch={setSearch}
            setSelectedFilter={setSelectedFilter}
            currentPage={currentPage}
            perPage={perPage}
            totalRecords={totalRecords}
            setCurrentPage={setCurrentPage}
            setPerPage={setPerPage}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}
export default ProviderDetail
